<div class="hx-release-notes-renderer" [class.hx-release-notes-renderer--preview]="isPreviewMode()">
  <!-- Header -->
  <header class="hx-release-notes-renderer__header">
    <h2 class="hx-release-notes-renderer__title">What's new</h2>
    <p class="hx-release-notes-renderer__subtitle">
      Stay up to date with the latest features, improvements, and fixes.
    </p>
  </header>

  <!-- Release Selector -->
  @if (showDropdown()) {
    <div class="hx-release-notes-renderer__selector">
      <hx-dropdown
        [options]="releaseOptions()"
        [value]="selectedReleaseId()"
        [customDisplayText]="dropdownDisplayText()"
        [customDisplaySubtitle]="''"
        [placeholder]="'Select a release'"
        size="sm"
        panelClass="hx-dropdown-panel--compact"
        [searchable]="true"
        (valueChange)="onReleaseChange($event)"
        class="hx-release-notes-renderer__dropdown" />
    </div>
  }

  <!-- Filter Chips -->
  @if (showFilters()) {
    <div class="hx-release-notes-renderer__filters">
      @for (option of filterOptions; track option.value) {
        <button
          class="hx-release-notes-renderer__filter-chip"
          [class.hx-release-notes-renderer__filter-chip--active]="selectedFilter() === option.value"
          [class.hx-release-notes-renderer__filter-chip--new]="option.value === ReleaseNoteItemTypeEnum.NEW"
          [class.hx-release-notes-renderer__filter-chip--improved]="option.value === ReleaseNoteItemTypeEnum.IMPROVED"
          [class.hx-release-notes-renderer__filter-chip--fixed]="option.value === ReleaseNoteItemTypeEnum.FIXED"
          [class.hx-release-notes-renderer__filter-chip--removed]="option.value === ReleaseNoteItemTypeEnum.REMOVED"
          [class.hx-release-notes-renderer__filter-chip--incident]="option.value === ReleaseNoteItemTypeEnum.INCIDENT"
          (click)="onFilterChange(option.value)">
          @if (option.icon && option.value !== 'all') {
            <hx-icon [svgIcon]="option.icon" [size]="12" />
          }
          <span>{{ option.label }}</span>
        </button>
      }
    </div>
  }

  <!-- Release List -->
  <div class="hx-release-notes-renderer__releases">
    @for (release of filteredReleases(); track release.releaseNoteId; let isFirst = $first) {
      <article class="hx-release-note-card">
        <!-- Release Header -->
        <header class="hx-release-note-card__header">
          <div class="hx-release-note-card__meta">
            <div class="hx-release-note-card__version-pill">
              @if (release.version) {
                <span>{{ release.version }} – {{ release.releaseName }}</span>
              } @else {
                <span>{{ release.releaseName }}</span>
              }
            </div>
            @if (showLatestBadge() && isLatestRelease(release.releaseNoteId)) {
              <div class="hx-release-note-card__badge hx-release-note-card__badge--latest">
                <hx-icon svgIcon="ccs-check" [size]="12" />
                <span>Latest</span>
              </div>
            }
          </div>
          <div class="hx-release-note-card__date-wrapper">
            <hx-icon fontIcon="ccs-calendar" class="hx-release-note-card__calendar-icon" [size]="12" />
            <time class="hx-release-note-card__date">
              {{ release.releaseDate | date: 'MMM d, yyyy' }}
            </time>
          </div>
        </header>

        <!-- Release Description -->
        @if (release.description) {
          <p class="hx-release-note-card__description">
            {{ release.description }}
          </p>
        }

        <!-- Release Items -->
        @if (release.items?.length) {
          <ul class="hx-release-note-card__items">
            @for (item of release.items; track item.itemId) {
              <li class="hx-release-note-item">
                <div
                  class="hx-release-note-item__badge"
                  [class.hx-release-note-item__badge--new]="item.type === ReleaseNoteItemTypeEnum.NEW"
                  [class.hx-release-note-item__badge--improved]="item.type === ReleaseNoteItemTypeEnum.IMPROVED"
                  [class.hx-release-note-item__badge--fixed]="item.type === ReleaseNoteItemTypeEnum.FIXED"
                  [class.hx-release-note-item__badge--removed]="item.type === ReleaseNoteItemTypeEnum.REMOVED"
                  [class.hx-release-note-item__badge--incident]="item.type === ReleaseNoteItemTypeEnum.INCIDENT">
                  <hx-icon [svgIcon]="getItemIcon(item.type)" [size]="12" />
                  <span>{{ item.type | titlecase }}</span>
                </div>
                <div class="hx-release-note-item__content">
                  <strong class="hx-release-note-item__title">{{ item.title }}</strong>
                  <div class="hx-release-note-item__description" [innerHTML]="sanitizeContent(item.content)"></div>
                </div>
              </li>
            }
          </ul>
        }
      </article>
    } @empty {
      <div class="hx-release-notes-renderer__empty">
        <hx-icon svgIcon="ccs-info-circle" size="large" />
        <p>No release notes available.</p>
      </div>
    }
  </div>
</div>
